import { axios } from 'src/lib/axios';

export type ImgUploadResponse = {
  code: number;
  msg: string;
  imgURL: string;
};

export type ImgUploadAreaType =
  | 'PROFILE'
  | 'STUDIO'
  | 'REPPL'
  | 'EPISODE'
  | 'LABEL';
export type ImgUploadType =
  | 'avatar'
  | 'cover'
  | 'studio_img'
  | 'studio_cover'
  | 'reppl_avatar'
  | 'reppl_cover'
  | 'episode_img'
  | 'episode_cover'
  | 'about_img'
  | 'label_img';

export type ImageRequest = {
  imgType: ImgUploadType;
  areaType: ImgUploadAreaType;
  id: string;
  data: FormData;
};

export const postUploadImage = (req: ImageRequest) =>
  axios
    .post<ImgUploadResponse>(
      `/image/${req.areaType}/${req.id}/${req.imgType}`,
      req.data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
    .then((res) => res.data);
